import { Flex } from '@posten-hedwig/flex'
import { Card } from '@posten/hedwig-react'

const MagazineCards = ({ cards }) => {
    return (
        <div className='hw-container hw-container--mb'>
            <Flex wrap='thirds' gutterDesktop='larger' gutterMobile='larger'>
                {cards.map((card, index) => (
                    <Card
                        url={card.url}
                        title={card.title}
                        overline={card.overline}
                        description={card.description}
                        imgUrl={card.imgUrl}
                        key={index}
                    />
                ))}
            </Flex>
        </div>
    )
}

export default (props) => <MagazineCards {...props} />